import CompanySelectorContainer from './containers/CompanySelectorContainer'

export default CompanySelectorContainer
